import logoImg from "../../svg/logo.svg";
import "./Logo.scss";

export default function Logo(){
    return<>
    <div className="logo_container">
        {/* <h5>Vikramshila Logo</h5> */}
        <img src={logoImg} alt="logo" />
    </div>
    </>
}